import React, { useState } from "react";
import { Modal } from "react-responsive-modal";
import { Link } from "gatsby";
import styled from "styled-components";
import * as SC from "./ManageCookiesModalStyle";
import Button from "../button";
import { Button as StyledButton } from "./style";
import {
  acceptAllCookiesSettings,
  rejectNonEssentialCookiesSettings,
  CookieSettingsEmum,
  updateCookieSettings,
} from "./CookiesSettings";

const CustomLink = styled(Link)`
  color: #fff;
`;

const ManageCookiesModal = props => {
  const [customCookiesSettings, setCustomCookiesSettings] = useState({
    [CookieSettingsEmum.ESSENTIAL_COOKIES]: true,
    [CookieSettingsEmum.ANALYTICAL_PERFORMANCE_COOKIES]: false,
    [CookieSettingsEmum.MARKETING_COCIAL_MEDIA_COOKIES]: false,
  });

  const accepAllCookies = () => {
    acceptAllCookiesSettings();
    props.onClose();
  };

  const rejectAllCookies = () => {
    rejectNonEssentialCookiesSettings();
    props.onClose();
  };

  const handleSwtich = element => {
    const { checked, value } = element.target;
    setCustomCookiesSettings(prev => ({
      ...prev,
      [value]: checked,
    }));
  };

  const customCookies = () => {
    updateCookieSettings(customCookiesSettings);
    props.onClose();
  };

  return (
    <React.Fragment>
      <Modal
        {...props}
        center
        showCloseIcon={false}
        closeOnEsc={false}
        closeOnOverlayClick={false}
        styles={{
          modal: {
            padding: "unset",
            margin: "unset",
          },
        }}
      >
        <SC.Container>
          <SC.Title>Cookies: You have the control</SC.Title>
          <span>
            On this site we have essential cookies which are needed for the site
            to work. We also have a couple of analytics and marketing cookies to
            help us know how to improve the site experience.
          </span>
          <span>
            Here's what you can do below
            <ol>
              <li>Accept all cookies and be done</li>
              <li>Reject all non-essential cookies and be done</li>
              <li>
                Click Make cookie choices and choose individual cookies to turn
                on or off
              </li>
            </ol>
          </span>
          <span>
            If you really love this stuff,{" "}
            <CustomLink to={"/cookie-information"}>
              learn more about how we use cookies at our cookies info page.
            </CustomLink>
          </span>

          <SC.SwitchContainer>
            <div>
              <b>Essential Cookies</b>
              <span>
                These cookies are essential for our website to work and can only
                be disabled by changing your browser preferences.
                <SC.Switch
                  size="xs"
                  name="cookieSettings"
                  onChange={handleSwtich}
                  value={CookieSettingsEmum.ESSENTIAL_COOKIES}
                  checked={
                    customCookiesSettings[CookieSettingsEmum.ESSENTIAL_COOKIES]
                  }
                />
              </span>
            </div>

            <div>
              <b>Analytical/Performance Cookies</b>
              <span>
                These cookies help us understand website activity, like page
                visits and visitor geography, so we can analyze data. The
                information collected does not identify visitors.
                <SC.Switch
                  size="xs"
                  name="cookieSettings"
                  onChange={handleSwtich}
                  value={CookieSettingsEmum.ANALYTICAL_PERFORMANCE_COOKIES}
                  checked={
                    customCookiesSettings[
                      CookieSettingsEmum.ANALYTICAL_PERFORMANCE_COOKIES
                    ]
                  }
                />
              </span>
            </div>

            <div>
              <b>Marketing & Social Media</b>
              <span>
                We use a few marketing and social media cookies that may track
                your browsing across sites to learn about your interests. The
                ones we use will help us learn about how Linkedin interacts with
                our site and will help google personalize your browsing.
                <SC.Switch
                  size="xs"
                  name="cookieSettings"
                  onChange={handleSwtich}
                  value={CookieSettingsEmum.MARKETING_COCIAL_MEDIA_COOKIES}
                  checked={
                    customCookiesSettings[
                      CookieSettingsEmum.MARKETING_COCIAL_MEDIA_COOKIES
                    ]
                  }
                />
              </span>
            </div>
          </SC.SwitchContainer>

          <SC.ButtonContainer>
            <Button
              text="Save my cookie choices"
              color="fff"
              bordercolor="fff"
              hovercolor="282828"
              hoverbackcolor="fff"
              onClick={customCookies}
            />

            <div>
              <Button
                text="reject all non-essential cookies"
                color="fff"
                bordercolor="fff"
                hovercolor="282828"
                hoverbackcolor="fff"
                onClick={rejectAllCookies}
              />
              <StyledButton onClick={accepAllCookies}>
                accept all cookies
              </StyledButton>
            </div>
          </SC.ButtonContainer>
        </SC.Container>
      </Modal>
    </React.Fragment>
  );
};

export default ManageCookiesModal;
